/**
 * Roadmap produit affichée aux admins — source curée, embarquée au build.
 *
 * ⚠️ Uniquement des features présentables à un client : jamais de bugs, de
 * décisions d'archi ni de considérations commerciales. Libellés via i18n :
 * `roadmap.items.<key>.title` / `roadmap.items.<key>.description` (fr + en).
 *
 * Miroir du GitHub Project (https://github.com/orgs/PureLMS/projects/1) : les
 * items `Public=Oui` y portent leur `Roadmap key` = la clé ci-dessous, et leur
 * `Status` détermine le `status` ici (Livré→done, Prêt/En cours/En review→
 * planned, Backlog/À l'étude→exploring). Ce fichier étant embarqué au build,
 * la synchro est manuelle — le skill `roadmap` fournit le script de détection
 * de dérive. Les items `done` historiques n'ont pas d'issue et sont hors diff.
 */

export type RoadmapStatus = 'done' | 'planned' | 'exploring'

export type RoadmapItem = {
  /** Clé i18n de l'item (title + description). */
  key: string
  status: RoadmapStatus
}

export const ROADMAP_ITEMS: RoadmapItem[] = [
  // Disponible
  { key: 'branding', status: 'done' },
  { key: 'scorm', status: 'done' },
  { key: 'sessions', status: 'done' },
  { key: 'statistics', status: 'done' },
  { key: 'privacy', status: 'done' },
  { key: 'selfHosted', status: 'done' },
  { key: 'modulePreview', status: 'done' },
  { key: 'learnerHome', status: 'done' },
  { key: 'certificates', status: 'done' },
  { key: 'learnerExperience', status: 'done' },
  { key: 'emailReminders', status: 'done' },
  { key: 'magicLink', status: 'done' },
  { key: 'sso', status: 'done' },

  // À venir
  { key: 'csvImport', status: 'done' },

  // À l'étude
  { key: 'webhooks', status: 'exploring' },
  { key: 'xapi', status: 'exploring' },
  { key: 'organizations', status: 'done' },
  { key: 'orgUrl', status: 'done' },
  { key: 'billing', status: 'done' },
  { key: 'payments', status: 'exploring' },
]
